import React from "react";

const Blog = () => {
    return (
        <div>
            {/* Header Section */}
            <div className="relative px-6 pt-14 lg:px-8">
                <div className="mx-auto max-w-4xl py-16 text-center">
                    <h1 className="text-5xl font-bold text-dark mb-6">Blog</h1>
                    <p className="text-lg text-muted mb-8">
                        Stay updated with the latest news and stories.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Blog;
